import React, { useState } from 'react';
import {
  Form,
  InputGroup
} from 'react-bootstrap';
import './index.css';
import StatesCities from "../../../../assets/json/states-and-districts.json";

function PropertyForm({ propertyData, setPropertyData, stateCities, getStateCities, inputError, setInputError }) {

  function handleChange(e) {
    let { id, value } = e.target;
    if (id === 'state') {
      getStateCities(value);
    }

    setInputError({ ...inputError, [id]: '' });
    setPropertyData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  return (
    <div className='form-wrapper h-100 pt-3'>
      <Form>
        <div className='row'>
          <div className='col-md-8 col-12'>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Project Name *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter project name"
                onChange={handleChange}
                className={inputError && inputError.name ? 'border-danger text-capitalize' : 'text-capitalize'}
                value={propertyData && propertyData.name}
                isInvalid={inputError && inputError.name}
              />
              <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='col-md-4 col-12'>
            <Form.Group className="mb-3" controlId="type">
              <Form.Label>Property Type *</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setPropertyData({
                    ...propertyData,
                    type: e.target.value,
                  });
                  setInputError({ ...inputError, type: '' })
                }}
                value={propertyData && propertyData.type}
                isInvalid={inputError && inputError.state}
              >
                <option value={'Building'}>Building</option>
                {/* <option value={'Land'}>Land</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
            </Form.Group>
          </div>
          {
            propertyData && propertyData.type === 'Land' ?
              <div className='col-md-6 col-12'>
                <InputGroup>
                  <Form.Group className="w-70" controlId="totalArea">
                    <Form.Label>Total Area</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="0"
                      onChange={handleChange}
                      className={inputError && inputError.totalArea ? 'border-danger border-right-0' : 'border-right-0'}
                      value={propertyData && propertyData.totalArea}
                      isInvalid={inputError && inputError.totalArea}
                    />
                  </Form.Group>
                  <Form.Group className="w-30 ps-1px" controlId="unitMeasure">
                    <Form.Label></Form.Label>
                    <Form.Select
                      className='border-left-0 mt-2 bg-primary-light'
                      onChange={handleChange}
                      value={propertyData && propertyData.unitMeasure}
                    >
                      <option value="sqft">sqft</option>
                      <option value="sqy">sqy</option>
                      <option value="sqm">sqm</option>
                      <option value="acre">acre</option>
                      <option value="hectare">hectare</option>
                    </Form.Select>
                  </Form.Group>
                </InputGroup>
              </div>
              :
              <div className='col-md-6 col-12'>
                <Form.Group className='mb-3' controlId="unitMeasure">
                  <Form.Label>Unit Measure</Form.Label>
                  <Form.Select
                    onChange={handleChange}
                    value={propertyData && propertyData.unitMeasure}
                  >
                    <option value="sqft">sqft</option>
                    <option value="sqy">sqy</option>
                    <option value="sqm">sqm</option>
                    <option value="acre">acre</option>
                    <option value="hectare">hectare</option>
                  </Form.Select>
                </Form.Group>
              </div>
          }
          <div className='col-md-6 col-12'>
            <Form.Group className="mb-3" controlId="number">
              <Form.Label>Street Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter street address"
                onChange={handleChange}
                className={inputError && inputError.number ? 'border-danger' : null}
                value={propertyData && propertyData.number}
                isInvalid={inputError && inputError.number}
              />
              <Form.Control.Feedback type="invalid">{inputError && inputError.number}</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='col-md-6 col-12'>
            <Form.Group className="mb-3" controlId="locality">
              <Form.Label>Sector/Locality *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter sector/locality"
                onChange={handleChange}
                className={inputError && inputError.locality ? 'border-danger' : null}
                value={propertyData && propertyData.locality}
                isInvalid={inputError && inputError.locality}
              />
              <Form.Control.Feedback type="invalid">{inputError && inputError.locality}</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='col-md-6 col-12'>
            <Form.Group className="mb-3" controlId="state">
              <Form.Label>State *</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setPropertyData({
                    ...propertyData,
                    state: e.target.value,
                  });
                  setInputError({ ...inputError, state: '' })
                  getStateCities(e.target.value);
                }}
                value={propertyData && propertyData.state}
                isInvalid={inputError && inputError.state}
              >
                <option>Select</option>
                {
                  StatesCities && StatesCities.map((item, index) => {
                    return (
                      <option key={index} value={item.state}>{item.state}</option>
                    )
                  })
                }
              </Form.Select>
              <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='col-md-6 col-12'>
            <Form.Group className="mb-3" controlId="city">
              <Form.Label>City *</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setPropertyData({
                    ...propertyData,
                    city: e.target.value,
                  });
                  setInputError({ ...inputError, city: '' })
                }}
                value={propertyData && propertyData.city}
                isInvalid={inputError && inputError.city}
              >
                <option value="">Select</option>
                {
                  stateCities && stateCities.map((city, index) => {
                    return (
                      <option key={index} value={city}>{city}</option>
                    )
                  })
                }
              </Form.Select>
              <Form.Control.Feedback type="invalid">{inputError && inputError.city}</Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className='col-md-6 col-12'>
            <Form.Group className="mb-3" controlId="pincode">
              <Form.Label>Pincode</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter pincode"
                onChange={handleChange}
                value={propertyData && propertyData.pincode}
              />
            </Form.Group>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default PropertyForm;
